module.exports = __webpack_public_path__ + "img/loading.386934bd.gif";